import {
  api,
  clearGlobalData,
  clearUser,
  setPage,
  useAppDispatch,
} from '@spartalabs/pdc-core';
import { logoutPortalSession } from './logoutPortalSession';

type PortalSessionDispatch = ReturnType<typeof useAppDispatch>;

export const PORTAL_PERMISSIONS_SCHEMA_KEY = 'portal-permissions-schema';
export const CURRENT_PORTAL_PERMISSIONS_SCHEMA = '3';

const PERSIST_ROOT_KEY = 'persist:root';

export const clearPortalPersist = (): void => {
  try {
    localStorage.removeItem(PERSIST_ROOT_KEY);
    localStorage.removeItem(PORTAL_PERMISSIONS_SCHEMA_KEY);
  } catch {
    // Ignora falhas de storage (modo privado, quota, etc.).
  }
};

export const markPortalPermissionsSchema = (): void => {
  try {
    localStorage.setItem(
      PORTAL_PERMISSIONS_SCHEMA_KEY,
      CURRENT_PORTAL_PERMISSIONS_SCHEMA,
    );
  } catch {
    // Ignora falhas de storage.
  }
};

export const hasCurrentPortalPermissionsSchema = (): boolean =>
  localStorage.getItem(PORTAL_PERMISSIONS_SCHEMA_KEY) ===
  CURRENT_PORTAL_PERMISSIONS_SCHEMA;

export const endPortalSession = async (
  dispatch: PortalSessionDispatch,
  accessToken?: string | null,
  refreshToken?: string | null,
): Promise<void> => {
  dispatch(setPage({ page: null }));
  await logoutPortalSession(accessToken, refreshToken);
  dispatch(clearUser());
  dispatch(clearGlobalData());
  dispatch(api.util.resetApiState());
  clearPortalPersist();
};
